<section class="card-cont p-lg-4">
    <article class="row">
        <ng-container *ngIf="isLoading; else showContent">
            <section class="col-lg-4 col-md-4 col-12 pr-lg-3" *ngFor="let loader of ' '.repeat(9).split('')">
                <div class="skeleton-loader skeleton-loader__workout-card row mx-0 mb-4">
                    <div class="skeleton-loader__details col-12 p-3">
                        <ngx-skeleton-loader class="d-block" style="margin-top: 55px;" count="3" appearance="circle"
                            animation="pulse" [theme]="{ 
                        height: '20px',
                        width: '20px',
                        'margin': '0',
                        'margin-right': '5px',
                        'background-color': '#E4E6ED'
                        }"></ngx-skeleton-loader>
                        <ngx-skeleton-loader count="1" animation="pulse" [theme]="{
                            'border-radius': '8px',
                            height: '25px',
                            width: '65%',
                            'background-color': '#E4E6ED',
                            'margin-bottom': '5px'
                        }"></ngx-skeleton-loader>
                        <!-- TODO: Uncomment the following when coach name and equipment data is applied -->
                        <!-- <ngx-skeleton-loader
                        count="1"
                        animation="pulse"
                        [theme]="{
                            'border-radius': '8px',
                            height: '15px',
                            width: '40%',
                            'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="1"
                        animation="pulse"
                        [theme]="{
                            'border-radius': '8px',
                            height: '15px',
                            width: '30%',
                            'background-color': '#E4E6ED',
                            'float': 'right'
                        }"
                    ></ngx-skeleton-loader> -->
                    </div>
                </div>
            </section>
        </ng-container>
        <ng-template #showContent>
            <ng-container *ngIf="workoutData.length > 0; else noWorkouts">
                <div class="col-lg-4 col-md-4 col-12 " *ngFor="let workout of workoutData | slice:0:dataDisplayCount">
                    <div class="workout" [ngStyle]="{ 'background-image': 'url(' + workout.mediaUrl + ')' }"
                        (click)="goToWorkoutDetails(workout.id, workout.isForMembersOnly)">

                        <div class="workout__overlay d-flex flex-column justify-content-between">
                            <div class="for-members-only-tag--sm" *ngIf="workout.isForMembersOnly === true">
                                {{ 'dialogs.forMembersOnlyText' | translate }}
                            </div>
                            <article class="mt-auto">
                                <p class="ellipsis" title="{{ workout.title }}">{{ workout.title }}</p>
                                <!-- <div>
                                    <small>Coach Name</small>
                                    <small class="workout__equipment">Full Equipment</small>
                                </div> -->
                            </article>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #noWorkouts>
                <div class="col-12">
                    <h6 class="text-center mt-4 mb-5"> {{ 'pages.noWorkoutsFoundMessage' | translate }}</h6>
                </div>
            </ng-template>
        </ng-template>
    </article>
</section>
<section class="unlock-overlay" *ngIf="openForMembersOnly">
    <article class="row no-gutters h-100 align-items-center text-center">
        <div class="mx-auto px-3 unlock-overlay-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg close-button" viewBox="0 0 16 16" (click)="openForMembersOnly = false"><path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/></svg>
            <img src="https://d3uee0gs4p7cty.cloudfront.net/icons/member-lock-icon.png" class="icon-lock"
                alt="Lock Icon">
            <h2 *ngIf="isStatusPending !== true" class="my-sm-5 mt-4 mb-5">{{ 'pages.unlockWorkout' | translate }}</h2>
            <h2 *ngIf="isStatusPending === true" class="my-sm-5 mt-4 mb-5">{{ 'dialogs.forMembersOnlyText' | translate }}</h2>
            <div class="col-lg-7 col-sm-8 col-9 mx-auto">
                <fitscovery-ui-be-a-member-button [isWithinPage]="true" [isWithinUnlockPage]="true">
                </fitscovery-ui-be-a-member-button>
                <a class="btn btn-back" (click)="backToList(true)">{{ 'dialogs.checkOtherWorkoutButtonText' | translate }}</a>
            </div>
        </div>
    </article>
</section>